import { useState, useEffect } from 'react';
import {NavLink} from 'react-router'; 
import './Profile.css';
import TableView from '../meTable/TableView';
import {ToNotify} from 'fast_inon';
import {base} from '../Config/app'
import {Ts} from '../Config/switcher';
import { InOption } from '../Shared/InputControl';
//import {Cookie} from '../Shared/Api.js'

const ProfileItems = ({lang, member=0, onEtat}) => {

    const [message, Message] = useState('')

    const T = (value, key='profile') => Ts(lang, key, value)

    const onCell = (item) => {
      //alert(`node=${item.Value}`)
      onEtat && onEtat(`node=${item.Value}`)
    }

    //alert(JSON.stringify(account))

return (

<div className="Home" id="MainContainer">

{ member>0 ?  
  <div className='CollapseTab'> 
    <TableView entity={{name:'Profile', id:member, parent:member}}  request={`/member`} onChange={onCell} />
  </div>
: <h2>{T('login')}</h2> }

<ToNotify 
    message={message}
    onClose={()=>{Message('')}}
/>

</div>
        )
}

const ProfileMain = ({lang, account, Login}) => {
  const T = (value, key='profile') => Ts(lang, key, value)
  
  const onProfile = (e) => {
      //alert("onProfile")
    if(account.connected) {
      const element = document.getElementById("ProfileItems")
      if(element) {
        if(element.style.visibility === 'hidden')
          element.style.visibility = 'visible'
        else
          element.style.visibility = 'hidden'
      }
    }
    else {
      Login(true)
    }
  }

  useEffect(()=>{

      if(account.Name==='') {
        //alert(account.message)
        //let infos = account.message?.split(' ')
        //account.Name = infos[1]
      }

      let item = document.getElementById("meProfileName")
      if( item) {
          item.innerHTML = account.connected ? T('salaam') : T('login');
          item.title = item.innerHTML+" "+account.Name;
      }
      
      item = document.getElementById("meProfilePhoto")
      if(item) {
          item.src = account.Id>0 ? `${base.app_url}/App_Data/Accounts/${account.Id}/photo.png` : 'images/avatar.png'
          item.title = account.Name;
      }


  },[account, lang])

  return (
    <>
        <button id="meProfile" className='ActionButton'
          onClick={onProfile}>
            <img id="meProfilePhoto" alt={account?.Name} src="images/avatar.png" title={T('salaam')} />
            <p id="meProfileName">Login</p>
        </button>

        <ProfileMenu lang={lang} account={account} />
    </>

  )
}

const onMouseLeave = (event) => {
  //event.currentTarget.blur();
  const element = document.getElementById("ProfileItems")
  if(element) {
    element.style.visibility = 'hidden'
  }
};

const ProfileMenu = ({lang, account}) => {

  useEffect(()=>{
    const element = document.getElementById("ProfileItems")
    if(element) {
      const lis = element.querySelectorAll('li')
      lis.forEach(li => {
        if (!li.onclick) {
          li.onclick = onMouseLeave
        }
      })
    }
  },[])

  
  //alert(`ProfileMenu:account = ${JSON.stringify(account)}`)
  const T = (value, key='profile') => Ts(lang, key, value)

  useEffect(()=>{
    ["myName", "myEmail","myRole"].forEach(id => {
        const element = document.getElementById(id) 
        if(element) {
            //	alert(element.id)
            const value = account[id.substring(2)]
            if(value?.length>0) {
              if(id==='myRole') {
                  element.value = value
                  element.disabled = true
              }
              else {
                  element.innerText = value
                  element.title=value
              }
            }
            else {
              /*
              switch(id) {
                case 'myRole':
                  element.value = account['roles']
                  break
                case 'myName':
                  element.title = account['message']
                  element.innerText = element.title.substring(element.title.indexOf(' '))
                  break
                case 'myEmail':
                  element.innerText = Cookie('meEmail') ?? Cookie('mePhone') ?? '***'
                  break
                
                default:
                  return
              }
              */
              //alert(`${id} ->${element.value} from ${JSON.stringify(account)}`)
            }
        }
    });
  },[account, lang])

  const onLogout = (e) => {
      //alert('remove localStorage')
      let store = localStorage.getItem(base.name)
      if(store) {
        localStorage.removeItem(base.name)
        window.location.reload()
      }
  }

  return (
    <div id="ProfileItems" style={{visibility:'hidden'}}>
      <ul>
          <li className="my" id="myName"></li>
          <li className="my" id="myEmail"></li>
          <li className="my" id="myRole">
            <InOption entity='myRole'
                  options={T('roles')} 
                  selected={account.Role} 
                  readOnly={true} 
            />
          </li>
      </ul>
      <div className="divider"></div>
      <ul>
        
        <li><a href="https://moshaf.akademy.ma/aayaat/index.html" target="_blank" rel="noopener noreferrer">{T('iqrae')} - 1</a></li>
        <li><a href="https://moshaf.akademy.ma/iqrae" target="_blank" rel="noopener noreferrer">{T('iqrae')}</a></li>
        <li><a href="https://moshaf.akademy.ma/aayaat/all.html" target="_blank" rel="noopener noreferrer">{T('search')}</a></li>
        <li><a href="https://tadabbor.akademy.ma/safahaat" target="_blank" rel="noopener noreferrer">{T('tadabbor')}</a></li>
        <li><a href="/sentence">{T('ihfad')}</a></li>
        <li><a href="/page">{T('tadabbor')}</a></li>
		    <li><a href="/profile">{T('profile')}</a></li>
        <li><a href="/audio">Audio</a></li>
        <li><a href="https://akademy.ma/#GetApp" target="_blank" rel="noopener noreferrer">AkademyApp</a></li>
        <li><a href="https://moshaf.akademy.ma/wajh/?course=5" target="_blank" rel="noopener noreferrer">Wajh</a></li>
        <li><a href="https://moshaf.akademy.ma/waqafaat" target="_blank" rel="noopener noreferrer">Waqafaat</a></li>
        <li><a href="https://moshaf.akademy.ma/monitor" target="_blank" rel="noopener noreferrer">{T('monitor')}</a></li>
        <li><a href="https://moshaf.akademy.ma/nass" target="_blank" rel="noopener noreferrer">{T('nass')}</a></li>
        <li><a href="https://moshaf.akademy.ma/aayaat" target="_blank" rel="noopener noreferrer">{T('aayaat')}</a></li>
        <li><a href="https://moshaf.akademy.ma/tilaawa" target="_blank" rel="noopener noreferrer">{T('tilaawa')}</a></li>
        <li><a href="https://moshaf.akademy.ma/tartyl" target="_blank" rel="noopener noreferrer">{T('tartyl')}</a></li>
        <li><a href="https://moshaf.akademy.ma/aayaat/vue.html" target="_blank" rel="noopener noreferrer">{T('all')}</a></li>
		    <li><a href="https://akademy.ma" target="_blank" rel="noopener noreferrer">{T('akademy')}</a></li>
        <li><a href="/setting">{T('setting')}</a></li>
      </ul>
      {account?.role==='Admin'?
        <ul>
          <div className="divider" style={{marginBottom:'0.5rem'}}></div>
          <li><NavLink to="/admin">{T('admin')}</NavLink></li>
        </ul>
      :null}
      <div className="divider"></div>
      <ul>
          <li style={{display:'block'}} onClick={onLogout}>{T('logout')}</li> 
      </ul>
    </div>
  )
}

export {ProfileMain, ProfileItems}
